import {IHistoryStep} from "./IHistoryStep";
import {noop} from "../../global/globalUtils";
import {SelectableObject} from "../selectableObjects";
import {HistoryStepSelObRemoved} from "./historyStepSelObRemoved";
import {HistoryController} from "./historyController";

export class HistoryDesignChange implements IHistoryStep {
    private readonly oldDesignName: string;
    private readonly newDesignName: string;
    private readonly selObHistorySteps = [];
    public type = "designChange";
    constructor(controller:HistoryController, parameters: { newDesign: string; oldDesign: string, logosThatWillBeDeleted:SelectableObject[]}, viewDetails) {
        this.oldDesignName = parameters.oldDesign;
        this.newDesignName = parameters.newDesign;
        parameters.logosThatWillBeDeleted.forEach(l=>{
            this.selObHistorySteps.push(new HistoryStepSelObRemoved(controller, {selOb:l, viewDetails}))
        })
    }

    setEndStateSelOb(id: string) {
        this.selObHistorySteps.forEach(s=>s.setEndStateSelOb(id));
    }
    cloneWasDeleted(origID: string, cloneID: string) {
        this.selObHistorySteps.forEach(s=>s.cloneWasDeleted(origID, cloneID));
    }
    cloneWasCreated(origId) {
        this.selObHistorySteps.forEach(s=>s.cloneWasCreated(origId));
    }
    replaceId(origID: string, newID: string) {
        this.selObHistorySteps.forEach(s=>s.replaceId(origID, newID));
    }

    undo(): void {
        EventVerteiler.broadcast("changeDesignRequestEvent", {designname:this.oldDesignName, byHistoryController:true});
        this.selObHistorySteps.forEach(s=>s.undo());
    }
    redo(): void {
        EventVerteiler.broadcast("changeDesignRequestEvent", {designname:this.newDesignName, byHistoryController:true});
        this.selObHistorySteps.forEach(s=>s.redo())
    }
}